import React from 'react';
import MarkdownView from 'react-showdown';
import { Box, ShowdownBox } from '../../components/element';
import { ShowContent } from '../../components/showContent';

export default function TechDocContent(props) {
  let showContent = <ShowContent contentString={props.mdString} />;
  if (props.contentType === 'react-showdown') {
    showContent = (
      <ShowdownBox>
        <MarkdownView markdown={props.mdString} />
      </ShowdownBox>
    );
  }
  return <Box className="marginBottom4 markdownContent">{showContent}</Box>;
}
